import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

import './styles/global.css';
import './styles/animations.css';
import './styles/layout.css';
import './styles/components.css';
import './styles/pages.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
